import { all, put, takeLeading } from 'redux-saga/effects'

import { actions } from '../index'
import ApiSagas from '../api/sagas'
import { services } from '../../graphql'

export default class PageSagas {
  static *onPageBySlugRequest({ payload }: ReturnType<typeof actions.page.getPageBySlugRequest>) {
    const rs = yield* ApiSagas.call(services.page.queries.pageBySlug, payload)
    if (rs.errors) {
      yield put(actions.page.getPageBySlugError(rs.errors))
    }

    if (rs.data) {
      yield put(actions.page.getPageBySlugSuccess(rs.data))
    }
  }

  static *listeners() {
    yield all([takeLeading(actions.page.getPageBySlugRequest, this.onPageBySlugRequest)])
  }
}
